module.exports = {
    TYPE : "WB",
    CAPABILITIES : 8,
    PROTOCOL_BYTE : 35,
    CURRENT_VERSION : 9
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/protocol/consts.js
// module id = 516
// module chunks = 1